import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Layout,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Card,
} from "antd";
import itemRender from "../../utils/itemsRender";
import {
  HomeOutlined,
  BankOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import TableViewLog from "../../components/TableViewLog";

function ViewLog(prop) {
 return (
        <>
            <Breadcrumb
            itemRender={itemRender}
            items={[
            {
                title: <HomeOutlined />,
                path: "/",
            },
            {
                title: (
                <>
                    <BankOutlined /> <span>View Log</span>
                </>
                ),
            },
            ]}
            style={{ margin: "16px 0" }}
            ></Breadcrumb>
            <Card
                    ghost="false"
                    title="View Log"
                    subtitle="This is a view log"
            >
            <TableViewLog />
            </Card>
        </>
 )
}

export default ViewLog;
